package features.members.ui.modals

import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import shared.ui.ModalManager

object EditMemberModal {
    fun render(root: HTMLElement) {
        root.append {
            div("modal-content fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-dark-800 border border-dark-700 rounded-2xl p-6 w-full max-w-md z-[101] hidden shadow-2xl") {
                id = "edit-member-modal"
                
                div("flex justify-between items-center mb-6") {
                    h3("text-xl font-bold") { +"Edit Member" }
                    button(classes = "text-slate-400 hover:text-white") {
                        onClickFunction = { ModalManager.close() }
                        +"✕"
                    }
                }
                
                input(type = InputType.hidden) { id = "edit-member-id" }
                
                div("space-y-4 mb-6") {
                    div {
                        label("block text-sm text-slate-400 mb-1") { +"Name" }
                        input(classes = "w-full bg-dark-900 border border-dark-700 rounded-xl p-3 text-slate-500 cursor-not-allowed") {
                            id = "edit-member-name"
                            readonly = true
                        }
                    }
                    div {
                        label("block text-sm text-slate-400 mb-1") { +"Email" }
                        input(classes = "w-full bg-dark-900 border border-dark-700 rounded-xl p-3 text-slate-500 cursor-not-allowed") {
                            id = "edit-member-email"
                            readonly = true
                        }
                    }
                    div {
                        label("block text-sm text-slate-400 mb-1") { +"Role" }
                        select("w-full bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                            id = "edit-member-role"
                            option { value = "owner"; +"Owner" }
                            option { value = "admin"; +"Admin" }
                            option { value = "member"; +"Member" }
                        }
                    }
                }
                
                div("flex justify-end gap-3") {
                    button(classes = "px-4 py-2 rounded-xl text-slate-300 hover:bg-dark-700 transition") {
                        onClickFunction = { ModalManager.close() }
                        +"Cancel"
                    }
                    button(classes = "px-4 py-2 rounded-xl bg-red-500/10 text-red-400 hover:bg-red-500/20 border border-red-500/20 transition") {
                        onClickFunction = { 
                            js("removeMember()")
                        }
                        +"Remove"
                    }
                    button(classes = "px-4 py-2 rounded-xl bg-brand-cyan text-white hover:bg-brand-green transition") {
                        onClickFunction = { 
                            js("saveMemberChanges()")
                        }
                        +"Save"
                    }
                }
            }
        }
    }
}
